import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {TPStorageService} from "../storage/tp-storage.service.ts";
import {StorageKeys} from "../../utills/enums/storage-keys";
import {DropDownOptionsModel} from "../../models/general";

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
    languageOptions: DropDownOptionsModel[] = [
        {value:'en', text: 'English'},
        {value:'fr', text: 'French'},
        {value:'ca', text: 'Catalan'},
        {value:'es', text: 'Spanish'},
        {value:'pt', text: 'Portuguese'},
    ];

    language: string = this.languageOptions[0].value;
    usedLanguage: DropDownOptionsModel = this.languageOptions[0];
    constructor(
        private translateService: TranslateService,
        private tpStorageService: TPStorageService
    ) { }

    init(): void {
        this.translateService.setDefaultLang(this.languageOptions[0].value);
        const browserLang =  this.translateService.getBrowserLang();
        let useLang = this.languageOptions[0].value;
        if(this.languageOptions.map(language => language.value).includes(browserLang)) { // supporting browser language
            useLang = this.tpStorageService.readLocalStorage(StorageKeys.Language) ?? browserLang ?? this.languageOptions[0].value;
        } else {
            useLang = this.tpStorageService.readLocalStorage(StorageKeys.Language) ?? this.languageOptions[0].value;
        }
        this.translateService.use(useLang);
        this.language = useLang;
        this.usedLanguage = this.findLanguage(useLang);
    }

    /**
     * @function changeLanguage
     * @description switches the ui language on behalf of the user. Flags the choice as deliberate so
     *              applyDefaultLanguage() never overrides it again on this device.
     * @return void
     * */
    changeLanguage(lang: string): void {
        this.setLanguage(lang);
        this.tpStorageService.writeLocalStorage(StorageKeys.LanguagePickedByUser, 'true');
    }

    /**
     * @function applyDefaultLanguage
     * @description hands a group of users a landing language (e.g. Catalan for UB SSO client contacts).
     *              Applied on every sign in, overriding whatever init() resolved from the browser or an
     *              earlier visit, but never a language the user picked from the language menu themselves.
     * @param lang language code, ignored when it is not one of languageOptions
     * @return void
     * */
    applyDefaultLanguage(lang: string): void {
        if (!this.findLanguage(lang)) return; // unsupported code, keep whatever init() resolved
        if (this.tpStorageService.readLocalStorage(StorageKeys.LanguagePickedByUser)) return;
        this.setLanguage(lang);
    }

    /**
     * @function setLanguage
     * @description applies and stores a language without claiming the user asked for it
     * @return void
     * */
    private setLanguage(lang: string): void {
        this.language = lang;
        this.usedLanguage = this.findLanguage(lang);
        this.translateService.use(lang);
        this.tpStorageService.writeLocalStorage(StorageKeys.Language, lang);
    }
    findLanguage(id): DropDownOptionsModel{
        return this.languageOptions.find(language => language.value === id);
    }
}